const getCurrentDateAt8AM = () => {
  const date = new Date();
  date.setHours(8, 0, 0, 0);
  return date;
};

export default getCurrentDateAt8AM;
